import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(main)/pools/[slug]/_components/PoolChartSectionWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(main)/profile/_components/HistoryHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(main)/profile/_components/HistoryWrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SwapTokenButton"] */ "/app/src/app/[locale]/(main)/profile/pools/[symbol]/_components/SwapTokenButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KYCAlertBanner"] */ "/app/src/components/shared/KYCAlertBanner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LockedAccountBanner"] */ "/app/src/components/shared/LockedAccountBanner/index.tsx");
